/**
 * Info-icoon met klikbare popover (werkt op desktop én mobiel/touch).
 * De native title blijft als snelle hover-tooltip; klik/tik opent direct
 * een leesbaar paneel, nog een klik of een klik buiten het paneel sluit het.
 */

import React, { useEffect, useRef, useState } from 'react';
import { Info } from 'lucide-react';

const InfoDot = ({ text }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onDoc = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onDoc);
    document.addEventListener('touchstart', onDoc);
    return () => {
      document.removeEventListener('mousedown', onDoc);
      document.removeEventListener('touchstart', onDoc);
    };
  }, [open]);

  return (
    <span ref={ref} style={{ position: 'relative', display: 'inline-flex' }}>
      <button
        type="button"
        onClick={() => setOpen((p) => !p)}
        aria-label="Uitleg"
        aria-expanded={open}
        title={open ? undefined : text}
        style={{
          background: 'transparent', border: 'none', padding: '2px',
          cursor: 'pointer', display: 'inline-flex', lineHeight: 0,
          color: open ? 'var(--color-blue-500)' : 'var(--color-neutral-400)',
        }}
      >
        <Info size={15} strokeWidth={2.2} />
      </button>
      {open && (
        <span
          role="tooltip"
          style={{
            position: 'absolute', top: 'calc(100% + 6px)', right: 0, zIndex: 60,
            width: '280px', maxWidth: '78vw',
            background: 'var(--surface-raised, var(--surface))',
            color: 'var(--color-neutral-700)',
            border: '1px solid var(--color-neutral-200)',
            borderRadius: 'var(--radius-md)',
            boxShadow: 'var(--shadow-lg)',
            padding: '10px 12px',
            fontSize: '0.78rem', lineHeight: 1.55, fontWeight: 400,
            textAlign: 'left', textTransform: 'none', letterSpacing: 0,
            whiteSpace: 'normal',
          }}
        >
          {text}
        </span>
      )}
    </span>
  );
};

export default InfoDot;
